import type { ChartDataPoint } from "../_create-chart-data-points";

import type { LegendTableCalculatedValueColumn } from "./_legend-table-calculated-value-column";

export interface LegendEntry {
	index: number;
	label: string;
	active: boolean;
	color: undefined | string;
	componentIdentifier: undefined | string;
}

export interface LegendEntryWithCalculatedValues extends LegendEntry {
	// preserve the calculated values in a Map for efficient table sorting
	calculated: ReadonlyMap<string, null | undefined | number>;
}

export function toLegendEntryWithCalculatedValues(
	entry: LegendEntry,
	points: ReadonlyArray<ChartDataPoint>,
	columns: ReadonlyArray<LegendTableCalculatedValueColumn>,
): LegendEntryWithCalculatedValues {
	if (columns.length === 0) {
		return { ...entry, calculated: new Map() };
	}

	const values = points.map((point) => point.values.at(entry.index) ?? null);
	const calculated = new Map(columns.map(({ label, calculate }) => [label, calculate(values)]));

	return { ...entry, calculated };
}
